import "./Footer.css";

const Footer = () => {
  return (
    <footer className="Footer" role="contentinfo">
      <small className="copyright">
        &copy; <span id="year"></span> Sasha Bajzek
      </small>
    </footer>
  );
};

export default Footer;
